import clsx from 'clsx'

import { ContentfulRichText } from '@/components/Contentful/common/ContentfulRichText'
import { Warning } from '@/components/Warning'

import { useEntry } from '../App.hooks'

type Props = {
	className?: string
	title?: string
	ctaText?: string
}

export function AppCaseStudies({
	className,
	title = 'Case Studies',
	ctaText = 'Read their story'
}: Props) {
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning>{entry.error}</Warning>
	}

	const { caseStudiesCollection } = entry.data ?? {}

	if (!caseStudiesCollection?.items.length) {
		return null
	}

	return (
		<section className={clsx(className, 'grid grid-cols-1 gap-6 mt-10 justify-items-start w-full')}>
			<h3 className="text-2xl font-medium text-bc-black">{title}</h3>
			{caseStudiesCollection?.items.map((item) => (
				<div key={item?.title} className="grid gap-2 justify-start">
					<p className="text-lg font-normal text-bc-black">{item?.title}</p>
					<ContentfulRichText field={{ data: item?.description }} />
					{item?.url && (
						<a href={item?.url} className="text-bc-blue text-[15px] font-normal" target="_blank">
							{ctaText}
						</a>
					)}
				</div>
			))}
		</section>
	)
}
